import classNames from "classnames";
import ObjectPreview from "./Object";
import { RelevanceType } from "types";
import useHoverDelay from "helpers/utility/utilities";
import RelevanceTypeIcon from "views/uikit/RelevanceTypeIcon";
import ScrollAwareHover from "views/components/ScrollAwareHover";

import styles from "./style.module.scss";
import ImageWithFallback from "../ImageWithFallback";

const ImagePreview = ({
  src,
  labels,
  hoverDelay,
  boundingBoxes,
  showAssetPreview,
  relevanceType = null,
  onUpdateAssetData,
  timestamp,
}: PreviewCardProps) => {
  const imageWrapperClassNames = classNames(styles.imageWrapper, {
    [styles.imageWrapperForAssetPreview]: showAssetPreview,
  });

  const { handleMouseEnter, handleMouseLeave } = useHoverDelay(
    onUpdateAssetData,
    hoverDelay,
  );

  return boundingBoxes.length > 0 ? (
    <ObjectPreview
      src={src}
      labels={labels}
      boundingBoxes={boundingBoxes}
      relevanceType={relevanceType}
      showAssetPreview={showAssetPreview}
      handleMouseEnter={handleMouseEnter}
      handleMouseLeave={handleMouseLeave}
      timestamp={timestamp}
    />
  ) : (
    <ScrollAwareHover
      className={imageWrapperClassNames}
      onMouseOver={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <>
        {relevanceType && <RelevanceTypeIcon type={relevanceType} />}
        <ImageWithFallback
          thumbImage={{ src }}
          plainImage={{ src }}
          alt="single img"
          data-testid="single-image"
          className={styles.plainImage}
        />
      </>
    </ScrollAwareHover>
  );
};

export default ImagePreview;

interface PreviewCardProps {
  src: string;
  labels: string[];
  hoverDelay: number;
  showAssetPreview: boolean;
  boundingBoxes: number[][];
  relevanceType?: RelevanceType | null;
  onUpdateAssetData: () => void;
  timestamp?: number;
}
